/**
 * Custom Notecard – Required Message Field Validation
 * Whitestone Branding / Alteryx Swag Store
 *
 * Uses MutationObserver to handle textarea injected late by Smart Product Builder (SPB).
 * Loaded conditionally via theme.liquid — only on products tagged NOTECARD
 * with handle custom-notecard.
 */

(function () {
  'use strict';

  /* ── Runtime URL guard ── */
  if (!window.location.pathname.includes('/products/custom-notecard')) return;

  var TEXTAREA_ID = 'Custom Message-0-0';
  var initialized = false;

  function init() {
    if (initialized) return;

    var textarea = document.getElementById(TEXTAREA_ID);
    var btn      = document.querySelector('button[name="add"]');
    var label    = document.querySelector('label[for="' + TEXTAREA_ID + '"]');
    var form     = document.querySelector('form.form');

    if (!textarea || !btn || !form) return;

    initialized = true;
    observer.disconnect(); // stop watching — elements are ready

    /* ── Required asterisk on label ── */
    if (label && !label.querySelector('.req-star')) {
      var star       = document.createElement('span');
      star.className = 'req-star';
      star.setAttribute('aria-hidden', 'true');
      star.textContent   = ' *';
      star.style.cssText = 'color:#e02b2b;font-weight:700;margin-left:2px;';
      label.appendChild(star);
    }

    /* ── Inline error message ── */
    var errorEl = document.getElementById('notecard-message-error');
    if (!errorEl) {
      errorEl              = document.createElement('p');
      errorEl.id           = 'notecard-message-error';
      errorEl.setAttribute('role', 'alert');
      errorEl.setAttribute('aria-live', 'assertive');
      errorEl.textContent  = '⚠️ Please enter your custom message before adding to cart.';
      errorEl.style.cssText = [
        'color:#e02b2b',
        'font-size:0.85rem',
        'font-weight:500',
        'margin-top:6px',
        'display:none'
      ].join(';');
      textarea.insertAdjacentElement('afterend', errorEl);
    }

    /* ── Error state helpers ── */
    function showError() {
      errorEl.style.display      = 'block';
      textarea.style.outline     = '2px solid #e02b2b';
      textarea.style.borderColor = '#e02b2b';
      textarea.setAttribute('aria-invalid', 'true');
    }

    function clearError() {
      errorEl.style.display      = 'none';
      textarea.style.outline     = '';
      textarea.style.borderColor = '';
      textarea.setAttribute('aria-invalid', 'false');
    }

    /* ── Intercept submit — capture phase fires before Shopify handlers ── */
    form.addEventListener('submit', function (e) {
      if (textarea.value.trim().length === 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError();
        textarea.scrollIntoView({ behavior: 'smooth', block: 'center' });
        textarea.focus();
      }
    }, true);

    /* ── Clear error once user types ── */
    textarea.addEventListener('input', function () {
      if (textarea.value.trim().length > 0) clearError();
    });
  }

  /* ── MutationObserver — watches for SPB to inject the textarea ── */
  var observer = new MutationObserver(function () {
    if (document.getElementById(TEXTAREA_ID)) init();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  /* ── Also attempt immediately in case elements already exist ── */
  init();

})();